import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { environment } from '../../environments/environment';
import { ConfigService} from '../config/config-service';


@Injectable()
export class LoginService {
	private config: ConfigService;

	constructor(private http: Http) {
		this.config = new ConfigService();
	}

	auth(host_api, data, dbname): any{
		let url = host_api + '/auth';
		let params = data;
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('dbname', dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res: Response) => {
			let json = res.json();

			if( json.data.token ){
				// GUARDAR DATOS DE INICIO DE SESION
			}

			return json;
		});
	}

	getCteByCodigo(codigo) {
		let url = environment.admin_api + '/clientes/' + codigo;
		let headers = new Headers({ 'Accept': 'application/json' });
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map(res => res.json());
	}

	authFactElectronica(host_api, data){
		let url = host_api + '/auth';
		let params = data;
		let headers = new Headers({ 'Content-type': 'application/json' });
		//headers.append('dbname', dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res: Response) => {
			let json = res.json();

			if( json.data.token ){
				// GUARDAR DATOS DE INICIO DE SESION
			}

			return json;
		});
	}
  
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/login.service.ts